export enum QUERY_PARAMS {
    TOKEN = 'btLpToken',
    PAYMENT_ID = 'btLpPaymentId',
    PAYER_ID = 'btLpPayerId',
}
